import { type Asset } from 'contentful';

import { useContentfulContentTypeEntry } from '@order/Contentful';

// ─────────────────────────────────────────────────────────────────────────────

export const useCustomizationContent = () => {
  const { data, fetching } = useContentfulContentTypeEntry<CustomizationContentFields>({
    contentType: CUSTOMIZATION_CONTENT_TYPE,
  });

  return { fields: data?.fields, fetching };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CUSTOMIZATION_CONTENT_TYPE = 'productDetailsPage';

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationContentFields = {
  dressingDetailsImage: Asset | undefined;
  orderCustomizeConfirmExitMessage: string | undefined;
  orderCustomizeConfirmExitConfirmButtonTitle: string | undefined;
  orderCustomizeConfirmExitCancelButtonTitle: string | undefined;
  outOfStockSingleIngredientBody: string | undefined;
  outOfStockMultipleIngredientsBody: string | undefined;
  outOfStockSingleIngredientButtonTitle: string | undefined;
  outOfStockMultipleIngredientsButtonTitle: string | undefined;
  restrictionModalTitle: string | undefined;
  restrictionModalButtonTitle: string | undefined;
  encourageChangesHeading: string | undefined;
  encourageChangesBaseHeading: string | undefined;
  encourageChangesNoSelectionHeading: string | undefined;
  encourageChangesBody: string | undefined;
  encourageChangesBaseBody: string | undefined;
  encourageChangesContinueButtonTitle: string | undefined;
  encourageChangesGoBackButtonTitle: string | undefined;
  requiredModificationBody: string | undefined;
  requiredModificationButtonTitle: string | undefined;
};
